<template>
	<div id="indexpage" v-title :data-title="title" style="height:100%;">
		<!-- <headerbar msg="chanyednao" :curindex="false"> </headerbar> -->
		
		<!-- 弹框 -->
			<el-drawer
			  title="我是标题"
			  :visible.sync="drawer"
			  :with-header="false" 
						:direction='direction2'
						:modal-append-to-body="modal"
					size='350px'> 
					  <bottomnav :activepage='13'></bottomnav> 
			</el-drawer> 
			<el-drawer
			  title="我是标题"
			  :visible.sync="drawer2"
			  :with-header="false" 
						:direction='direction'
						size='240px'
						:modal-append-to-body="modal"> 
					  <leftnav :isCollapse='isCollapse' :activenav='"3-4"'  :curindex='4'></leftnav>
			</el-drawer> 
			<span class="screen" @click="drawer2 = true"  ><i class="el-icon-s-unfold"></i>菜单栏</span> 
		<!-- 弹框 -->	
		
		<div class="por" style="background-color: #041034;height:100%;">
			<div class="index-swiper centerpage">
				<h2 class="title dataswipertitle" @click="drawer = true">{{userdata.cityText}}{{title}}<i class="el-icon-arrow-down dataswipertitle_icon"></i></h2>
				<div class="indexflex qxzsswiper">
					<div class="qxzs_top flexcss">
						<div class="qxzs_lastyear transparentbg">
							<h3 class="qxzs_title">去年全市招商情况</h3>
							<ul class="qxzs_yearlist transparentbg">
								<li>
									<h5 class="title">投资总额</h5>
									<p><strong class="numf">
											<countTo :endVal='2935' :startVal='0' :props="contodefault">100</countTo>
										</strong><span>亿元</span></p>
								</li>
								<li>
									<h5 class="title">投资数量</h5>
									<p><strong class="numf">
											<countTo :endVal='305' :startVal='0' :props="contodefault">370</countTo>
										</strong><span>个</span></p>
								</li>
							</ul>
						</div>
						<div class="qxzs_thisyear transparentbg">
							<h3 class="qxzs_title">今年全市招商情况</h3>
							<ul class="qxzs_yearlist transparentbg">
								<li>
									<h5 class="title">投资总额</h5>
									<p><strong class="numf">
											<countTo :endVal='3270' :startVal='0' :props="contodefault">100</countTo>
										</strong><span>亿元</span></p>
								</li>
								<li>
									<h5 class="title">投资数量</h5>
									<p><strong class="numf">
											<countTo :endVal='376' :startVal='0' :props="contodefault">370</countTo>
										</strong><span>个</span></p>
								</li>
							</ul>
						</div>
						<div class="qxzs_trend transparentbg">
							<h3 class="qxzs_title">趋势情况</h3>
							<div id="qxzs_trendchart"></div>
						</div>
						<div class="qxzs_policy transparentbg">
							<h3 class="qxzs_title">优惠政策</h3>
							<div class=" qxzs_policybox ">
								<ul class="flexcss">
									<!-- v-for="(list,i) in pagedata.policy" :class="i%2!=0?'zshjswiper_h4_list2':'zshjswiper_h4_list1'" -->
									<li class="list1">
										<h4>租金最大减免</h4>
										<p  class="yellfont"><countTo :endVal='100' :startVal='10'  :props="contodefault"> </countTo><span>万</span></p>
									</li>
									<li class="">
										<h4>税收最大优惠</h4>
										<p class="yellfont"><countTo :endVal='500' :startVal='100' :props="contodefault"> </countTo><span>万</span></p>
									</li>
									<li class="list1">
										<h4>上市最高奖励</h4>
										<p class="yellfont"><countTo :endVal='1000' :startVal='100' :props="contodefault"> </countTo><span>万</span></p>
									</li>
									<li class="">
										<h4>固投最大补贴</h4>
										<p class="yellfont"><countTo :endVal='10' :startVal='0' :props="contodefault"> </countTo><span>万</span></p>
									</li>
									<li class="list1">
										<h4>人才最高补贴</h4>
										<p class="yellfont"><countTo :endVal='100' :startVal='0' :props="contodefault"> </countTo><span>万</span></p>
									</li>
									<li class="">
										<h4>地价最大优惠</h4>
										<p class="yellfont"><countTo :endVal='20' :startVal='0' :props="contodefault"> </countTo><span>万</span></p>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="qxzs_bottom transparentbg flexcss">
						<div class="qxzs_bottom_left">
							<div id="qxzs_bottom_map"></div>
							<ul class="qxzs_bottom_list">
								<li>
									<h4 class="title">招商数量</h4>
									<p><countTo :startVal="1000" :endVal='endVal1' class="orangefont" :decimals="2" :props="contodefault"></countTo><span class="until">个</span></p> 
								</li> 
								 <li>
								 	<h4 class="title">招商金额</h4>
								 	<p><countTo :startVal="1000" :endVal='endVal2' class="orangefont" :decimals="2" :props="contodefault"></countTo><span class="until">亿元</span></p> 
								 </li> 
							</ul>
						</div>
						<div class="qxzs_bottom_right">
							<h3 class="qxzs_title">招商项目列表</h3>
							<div class="qxzs_tab"> 
								<div class="thbox">
									<ul class="flexcss"> 
										<li class="th_list2 ">地区</li>
										<li class="th_list1">项目名称</li>
										<li class="th_list2">所属行业</li> 
										<li class="th_list2">项目类型</li> 
										<li class="th_list2">项目金额（万元）</li>
										<li class="th_list2">日期</li>
										</ul> 
										</div>
										<div class="qxzs_scrollbox">
										<vue-seamless-scroll :data="projectlist"  :class-option="defaultOption"   >   <!-- :data="colors"  :class-option="defaultOption" -->
											<ul class=" flexcss " v-for="item in projectlist" >   
												<li class="th_list2">{{item.region}}</li>		
												<li class="th_list1">{{item.name}}</li>
												<li class="th_list2">{{item.industry}}</li> 
												<li class="th_list2">{{item.type}}</li> 
												<li class="th_list2">{{item.money}}</li>
												<li class="th_list2">{{item.date}}</li>
												</ul> 	    	 
									</vue-seamless-scroll >
								</div> 
							</div>
							<div class="qxzs_change">
							<h3 class="qxzs_title">招商项目变化</h3>
							<div id="qxzs_changechart"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	</div>
</template>
<script>
	import mappng from '../../../assets/images/mapbg.png';
	export default {
		name: 'quxianzonghe',
		data() {
			return {
				isCollapse:false,
				isFullscreen: false,
				direction:"ltr",  //btt
				direction2:"btt",  //btt
				 drawer: false,
					drawer2: false,
					modal:false,	
				title: "各区县招商大屏",
				bgcolor: "#041034",
				startVal: 0, //数字滚动开始值
				endVal1: 129, //数字滚动结束
				endVal2:140.86,
				usernotionlistsave: [],
				userdata: {},
				clynav: 1,
				clychartnav: 1,
				mapurl: 'map/city/321200.json',
				contodefault: {
					duration: 1000,
					autoplay: true,
				},
				islogin: false,
				flag: true,
				swipernum: 3,
				zoom: 13,
				public_tooltip: {
					trigger: 'axis',
					backgroundColor: 'rgba(255,255,255,0.9)',
					borderColor: '#ddd',
					borderWidth: '1',
					textStyle: {
						color: '#000',
						fontSize: 14,
					}
				},
				mapurl: 'map/city/321200.json',
				colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
				landType: [],
				startCharts: null,
				//假数据 
				fixassetsdata: [{
					name: "泰兴市", value: 101 }, { name: "靖江市", value: 120 }, {
					name: "兴华市", 	value: 130 	}, { name: "姜堰区", value: 176 }, { name: "高港区", value: 187 }, { name: "海陵区", value: 201 }],
				zdcydata: [{
					name: "第一产业",
					value: 203.31
				}, {
					name: "第二产业",
					value: 482.27
				}, {
					name: "第三产业",
					value: 344.02
				}],
				ydata: [{
						name: "高港区",
						value: 1432
					},
					{
						name: "泰兴市",
						value: 1253
					},
					{
						name: "海陵区",
						value: 1104
					},
					{
						name: "靖江市",
						value: 991
					},
					{
						name: "兴化市",
						value: 593
					},
					{
						name: "姜堰市",
						value: 460
					},
				],
				areadata: [{
						name: "2016",
						value: 1432
					},
					{
						name: "2017",
						value: 1253
					},
					{
						name: "2018",
						value: 1104
					},
					{
						name: "2019",
						value: 991
					},
					{
						name: "2020",
						value: 593
					},
					{
						name: "2021",
						value: 460
					},
				],
				projectlist:[
				{region:'姜堰区',name: "新能源汽车电驱传动部件产业化项目",industry:"新能源汽车",type:'独立投资',money:74000 ,date:'2022-02-18'},
				{region:'海陵区',name: "光伏封装材料扩产项目",industry:"光伏",type:'独立投资',money:20000 ,date:'2022-01-20'},
				{region:'海陵区',name: "药品、医疗器械及配套用乳膏生产项目",industry:"医药制造",type:'独立投资',money:53387 ,date:'2021-12-17'},
				{region:'泰兴市',name: "高性能石墨烯散热膜生产基地建设项目",industry:"石墨烯",type:'独立投资',money:58677 ,date:'2021-12-14'},
				{region:'靖江市',name: "石化专用设备生产项目",industry:"专用设备",type:'独立投资',money:50150 ,date:'2021-08-18'},
				{region:'高港区',name: "新建新型四价流感病毒裂解疫苗车间建设项目",industry:"疫苗",type:'独立投资',money:84500 ,date:'2021-07-15'},
				{region:'泰兴市',name: "PHC预应力高强度混凝土管桩生产基地项目",industry:"水泥",type:'独立投资',money:102000 ,date:'2021-07-09'},
				{region:'泰兴市',name: "年产22600吨酞菁颜料项目",industry:"颜料",type:'独立投资',money:75151 ,date:'2021-07-09'},
				{region:'泰兴市',name: "三元前驱体、四氧化三钴与配套镍钴锰锂原料体系的循环经济产业项目",industry:"正极材料",type:'独立投资',money:180000 ,date:'2021-06-06'},  
				],
			}
		},
		props: {
			msg: String,
		},
		computed: {
			defaultOption() {
				return {
					step: 0.7, // 数值越大速度滚动越快
					limitMoveNum: this.projectlist.length, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 1, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
				}
			}
		},
		mounted() {
			document.getElementById('app').style.background = this.bgcolor;
			this.userdata = this.getuseriformation();
			// console.log(this.userdata);
			// this.getajasdata(); 
			this.TaxchartFun();
				this.mapGeo('qxzs_bottom_map',this.ydata);
				this.changechartFun();
		},
		methods: {
			getajasdata() {
				var _this = this;
				// this.bus.$emit('loading', true);
				console.log(this.title);
				this.$axios.get(this.$api.cyl.govementchart.industryland(), {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log(res.data.data); 
						var datd = res.data.data; 
						_this.bus.$emit('loading', false); 
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},


			//趋势情况
			TaxchartFun() {
				var charPie3currentIndex = 0,
					isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var Taxchart = echarts.init(document.getElementById('qxzs_trendchart')); 
				var		option = {
				  title: {
				    text: '',
				  },
				  tooltip: {
				    show:true,
								trigger: 'axis'
				  },
				  legend: {
				    show:true,
								textStyle:{color:"#eee",fontSize:12,},
								icon:'rect',  //图例样式 圆点circle 矩形rect
								itemWidth:10,
								itemHeight:9, 
								right:'5%',
				  }, 
				  grid: {
				    left: '3%',
				    right: '4%',
				    bottom: '3%',
				    containLabel: true
				  },
				  xAxis: [
				    {
				      type: 'category',
				      boundaryGap: false,
										color:"#eee",
				      data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月'],
										axisLine: {show:true,  lineStyle:{ color:'#eee', } }, 		//轴线
										axisTick:{show:false }, //刻度线
				    }
				  ],
				  yAxis: [
				    {
				      type: 'value', 
										min:0,				//最小值
										// max: 400,			//最大值
										// interval: 100,		//步长值
										splitLine:{show:false}, //不显示网格线
										axisLine: {show:false,  lineStyle:{ color:'#eee', } }, 		//轴线
				    }
				  ],
				  series: [
				    {
														name: '项目数',
				          data: [20, 32, 41, 34, 10, 30, 20],
				          type: 'line',
				          smooth: true, //线条平滑
				          
														symbol:'circle', //拐点样式
														symbolSize: 5,//拐点大小
														color:'rgba(0,176,80,1)',
														areaStyle: {color:'rgba(0,176,80,.5)'},
														// stack: 'Total', //同个类目轴上系列配置相同的stack值后，后一个系列的值会在前一个系列的值上相加
				        },
				        {
													name: '金额（亿元）',
				          data: [20, 32, 32, 34, 20, 38, 28],
				          type: 'line',
				          smooth: true, //线条平滑
														symbol:'circle', //拐点样式
														symbolSize: 5,//拐点大小
														areaStyle: {color:'rgba(254,100,29,.5)'},
														color:'rgba(254,100,29,1)',
														// stack: 'Total', //同个类目轴上系列配置相同的stack值后，后一个系列的值会在前一个系列的值上相加
				        }	
				  ]
				};
				Taxchart.setOption(option);

			},
			
			//招商项目变化
			changechartFun() {
				var charPie3currentIndex = 0,
					isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var Taxchart = echarts.init(document.getElementById('qxzs_changechart')); 
				var		option = {
				  title: {
				    text: '',
				  },
				  tooltip: {
				    show:true,
								trigger: 'axis'
				  },
				  legend: {
				    show:true,
								textStyle:{color:"#eee",fontSize:12,},
								icon:'rect',  //图例样式 圆点circle 矩形rect
								itemWidth:10,
								itemHeight:9, 
								right:'5%',
				  }, 
				  grid: {
							top:'10%',
				    left: '3%',
				    right: '4%',
				    bottom: '10%',
				    containLabel: true
				  },
				  xAxis: [
				    {
				      type: 'category',
				      boundaryGap: false,
										color:"#eee",
				      data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月'],
										axisLine: {show:true,  lineStyle:{ color:'#eee', } }, 		//轴线
										axisTick:{show:false }, //刻度线
				    }
				  ],
				  yAxis: [
				    {
				      type: 'value', 
										min:0,				//最小值
										// max: 400,			//最大值
										// interval: 100,		//步长值
										splitLine:{show:false}, //不显示网格线
										axisLine: {show:false,  lineStyle:{ color:'#eee', } }, 		//轴线
				    }
				  ],
				  series: [
				    {
														name: '项目数',
				          data: [20, 32, 41, 34, 10, 30, 20],
				          type: 'line',
				          smooth: false, //线条平滑 
														symbol:'circle', //拐点样式
														symbolSize: 5,//拐点大小
														areaStyle: {color:'rgba(24,144,255,.5)'}, //阴影面积样式
														color:'rgba(24,144,255,1)', //单挑数据全局颜色
														// stack: 'Total', //同个类目轴上系列配置相同的stack值后，后一个系列的值会在前一个系列的值上相加 
				        },
				        {
													name: '金额（亿元）',
				          data: [10, 32, 32, 34, 20, 38, 28],
				          type: 'line',
				          smooth: false, //线条平滑 
														symbol:'circle', //拐点样式
														symbolSize: 5,//拐点大小
														areaStyle: {color:'rgba(255,192,0,.5)'}, //阴影面积样式
														color:'rgba(255,192,0,1)', //单挑数据全局颜色
														// stack: 'Total', //同个类目轴上系列配置相同的stack值后，后一个系列的值会在前一个系列的值上相加
				        }	
				  ]
				};
				Taxchart.setOption(option);
			
			},
			
			
			//地图
			mapGeo(el, data) {
							var myChart = echarts.init(document.getElementById(el));
							var mapUrl = this.mapurl;
							var _this = this;
							// console.log(data);
							var tootlips=this.public_tooltip; 
							$.getJSON(mapUrl, function(geoJson) {
								echarts.registerMap('taizhou', geoJson);
								myChart.hideLoading(); 
								var option = {
									backgroundColor: 'rgba(0,0,0,0)',
									title: {
										text: '',
										subtext: '',
										left: 20,
										bottom:130,
										textStyle: {
											color: '#fff',
											fontWeight: 700,
											fontSize: 18,
										},
									}, 
									// grid: {
									// 		        left: '3%',
									// 		        right: '4%',
									// 		        bottom: '3%',
									// 		        containLabel: true
									// 		    },
									tooltip:{
										alwaysShowContent: true,
										show: false,
										hoverAnimation: true,
										trigger: 'item', //触发类型 散点图
										enterable: true, //鼠标是否可进入提示框
										transitionDuration: 1, //提示框移动动画过渡时间
										// triggerOn: 'click',
										borderWidth: '1px',
										borderRadius: '4',
										borderColor: '#00B2AC',
										backgroundColor: "rgba(0,0,0,.8)",
										textStyle: {
											color: '#fff'
										}, 
										formatter:function(parms){
											return "<h4 class='oh'><span class='fl'>地区</span><span class='fr'>"+parms.name+"</span></h4><div class='oh'><span class='fl'>新增企业</span><span class='fr'>"+parms.value+"</span></div>";
										}
									},
									geo: {
										map: 'taizhou',
										aspectScale:0.8,
										layoutCenter: ['50%', '50.5%'],
										layoutSize: '100%',
										silent: true,
										roam: false,
										z: 0,
										itemStyle: {
											normal: {
												areaColor: 'rgba(255,0,0,0)', //地图背景阴影
												shadowColor: 'rgba(0, 0, 0, 1)',
												shadowBlur: 0,
												shadowOffsetX: 0,
												shadowOffsetY: 1,
												borderColor: 'rgba(0, 0, 0, 0.0)',  //地图背景边框
												borderWidth: 0.5,
											},
											emphasis: {
												areaColor: 'rgba(0,0,0,0)',
												borderWidth: 1,
												color: 'green',
												label: {
													show: true,
												},
											},
										},
									},
									series: [
										{
										type: 'map',
										zoom: 1.1, 
										aspectScale: 0.85, //地图的长宽比
										// roam: false,
										map: 'taizhou',
										roam: false, 
										data:data,
										label: {
											normal: {
												show: true,
												rotate:90,
												textStyle: {
													fontSize: 14,
													color: '#fff',
												},
											},
											emphasis: {
												textStyle: {
													color: '"rgba(150,174,206,1)"',
												},
											},
										},
										itemStyle: {
											normal: {
												borderColor: '#6185be',
												borderWidth: 1,
												// areaColor: {
												// 	image: mappng,
												// 	repeat: 'repeat',
												// },
												areaColor:"#045c99",
												shadowColor: '#96aece',
												shadowBlur: 0,
												shadowOffsetX: 0,
												shadowOffsetY: 1,
											},
											emphasis: {
												// areaColor: {
												// 	image: '#f60',
												// 	repeat: 'repeat',
												// },
												areaColor:"#023e64",
												borderColor: '#ccc',
												borderWidth: 1,
												shadowColor: '#96aece',
												shadowBlur: 10,
												shadowOffsetX: 2,
												shadowOffsetY: 1,
												label: {
													show: true,
												},
											},
										},
										
									},  
									],
								};
								myChart.setOption(option);
							});
							// 地图点击事件
							myChart.on('click', function(params) {
								console.log('selected',params.event.target.selected);
								//判断该市是否选中，true则改变该市的数据，false则显示默认数据
								if(params.event.target.selected){
									if(params.name=="泰兴市"){
									_this.endVal1=125.44;  //数字滚动结束值
								_this.endVal2= 455.44;  //数字滚动结束值 
								}else if(params.name=="兴化市"){
									_this.endVal1=1125.44;  //数字滚动结束值
										_this.endVal2= 1455.44;  //数字滚动结束值 
								}else if(params.name=="姜堰市"){
									_this.endVal1=4545.44;  //数字滚动结束值
										_this.endVal2= 2455.44;  //数字滚动结束值 
								}
								else if(params.name=="靖江市"){
									_this.endVal1=5545.44;  //数字滚动结束值
										_this.endVal2= 455.44;  //数字滚动结束值 
								}	else if(params.name=="高港区"){
									_this.endVal1=545.44;  //数字滚动结束值
										_this.endVal2= 1455.44;  //数字滚动结束值 
								}
								else if(params.name=="海陵区"){
									_this.endVal1=1545.44;  //数字滚动结束值
										_this.endVal2= 3455.44;  //数字滚动结束值 
								} else{
									_this.endVal1=123.44;  //数字滚动结束值
										_this.endVal2= 123.44;  //数字滚动结束值 
								}
								}else{
									_this.endVal1=129;  //数字滚动结束值
										_this.endVal2= 140.86;  //数字滚动结束值 
								}
								 
								
								
								
								console.log(params);
							});
						},

		}
	}
</script>

<style scoped="scoped">
</style>
